import { ListSourceType } from "@/enum/list.enum";

import { ListPerson } from "../../schema/list";

/*
 * Which rows hold a placeholder instead of a person. Kept apart from SelectProspectCell, which
 * reads the list from the API cache, so the many places that only ask "is this a placeholder?"
 * do not load the API layer with it (PREC-4399).
 */

// Tracker lists seed their rows with a "SELECT" placeholder prospect that the user replaces with
// a real person from the tracked organization.
export const isTrackerDummyProspect = (row: ListPerson): boolean =>
	row.prospect?.name === "SELECT" &&
	row.list?.sourceType === ListSourceType.TRACKER &&
	!!row.trackerSignalResult?.trackerOrganization?.id;

// Non-tracker imports mark unresolvable rows with a "Person not found" placeholder prospect.
export const isNonTrackerDummyProspect = (row: ListPerson): boolean =>
	row.prospect?.name === "Person not found";

export const isDummyProspect = (row: ListPerson): boolean =>
	isTrackerDummyProspect(row) || isNonTrackerDummyProspect(row);

// Name-only variant for surfaces that haven't loaded the full `ListPerson` row yet (the lead
// panel's action row before its chatLead resolves) — same placeholder names as above.
export const isPlaceholderProspectName = (name: string | null | undefined): boolean =>
	name === "SELECT" || name === "Person not found";
